import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Text,
  useDisclosure
} from '@chakra-ui/react';

interface CASBypassModalProps {
  onCloseComplete: () => void;
}
const CASBypassModal = (props: CASBypassModalProps) => {
  const { onCloseComplete } = props;

  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      id="casBypass-welcome"
      size="xl"
      closeOnOverlayClick={false}
      closeOnEsc={false}
      onCloseComplete={onCloseComplete}
    >
      <ModalOverlay />

      <ModalContent>
        <ModalHeader>Welcome to CAS Shield</ModalHeader>

        <ModalBody>
          <Text>
            You have now received your CAS to enable you to apply for your UK visa. Please use the CAS Shield system to
            keep us up to date with your visa application status and arrival to university, as well as provide us with
            any follow-up document requested on the system.
          </Text>

          <Text>
            The list of documents and guidelines provided in this process do not constitute legal advice, their purpose
            is to speed up your preparation. Any official visa and immigration advice will be provided as needed by our
            university staff and/or an assigned solicitor. If you receive advice from these parties, please ensure you
            follow it carefully.
          </Text>

          <Text>Please read and agree to the following statement to continue:</Text>

          <Text>
            <em>
              I understand that the visa and arrival process will require the collection of personal and sensitive
              information that belongs to me. This data will be processed by the university and approved representatives
              for the purpose of my application and enrolment.
            </em>
          </Text>
        </ModalBody>

        <ModalFooter>
          <Button id="saveButton" onClick={onClose} variant="solid">
            Agree &amp; continue
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CASBypassModal;
